<template>
  <aside aria-hidden="true">
    <div
      ref="bar"
      class="container"
      :class="{ '-sticky': sticky, '-bottom': bottom }"
    >
      <div class="h5 -upper" v-text="item.name"></div>
      <router-link
        tabindex="-1"
        :to="localizedUrl + '/store-locator'"
        class="btn -white -stroke -icon"
        :class="{ '-ecom': ecommerceActivated }"
        v-if="!item.onlyAvailableOnline && !item.product.is_icon"
      >
        <i class="icon-locator"></i>{{ $t("Shop in store") }}
      </router-link>
      <template
        v-if="ecommerceActivated && !item.product.is_icon && getProductPrice(item.product) !== 0"
      >
        <button
          tabindex="-1"
          type="button"
          class="btn -white"
          v-if="item.isInStock && !item.isPreorder"
          @click="addToCartAndFeedback(item.product)"
        >
          {{ $t("Add to cart") }}
        </button>
        <button
          tabindex="-1"
          type="button"
          class="btn -white"
          v-if="item.isInStock && item.isPreorder"
          @click="addToCartAndFeedback(item.product)"
        >
          {{ $t("Preorder") }}
        </button>
        <br v-if="item.isInStock" />
        <button
          tabindex="-1"
          type="button"
          class="btn -white"
          v-if="item.isShoppable && !item.isInStock"
          @click="alertAvailability"
        >
          {{ $t("Notify me when available") }}
        </button>
        <br v-if="item.isShoppable && !item.isInStock" />
      </template>
      <template v-if="item.product && item.product.is_icon">
        <router-link
          v-if="item.iconCtaLabel && item.iconCtaUrl"
          type="button"
          class="btn -white -stroke"
          :to="localizedUrl + item.iconCtaUrl"
          v-text="item.iconCtaLabel"
        ></router-link>
      </template>
    </div>
  </aside>
</template>

<script>
import { currentStoreView } from "@vue-storefront/core/lib/multistore";
import { mapActions, mapGetters, mapState } from "vuex";
import { ReadyHook } from "vue-asyncready";
import { getProductPrice } from '../utilities'

export default {
  props: ["item", "items", "size"],
  name: "sticky_product_bar",
  mixins: [ReadyHook],
  data() {
    return {
      autoReady: false,
      sticky: false,
      bottom: false,
      ecommerceActivated: undefined,
    };
  },
  mounted() {
    document.querySelector("main").classList.add("-product");
    window.addEventListener("scroll", this.isSticky);
    this.$ready();
    this.isSticky();
    this.ecommerceActivated = this.$store.state["zenith-ui"].ecommerce;
    setTimeout(() => {
      window.dispatchEvent(new Event("scroll"));
      window.dispatchEvent(new Event("resize"));
    }, 100);
  },
  methods: {
    getProductPrice: getProductPrice,
    ...mapActions("cart", { addToCart: "addItem" }),
    ...mapActions("feedback", ["show"]),
    ...mapGetters("user", ["isLoggedIn"]),
    isSticky() {
      this.sticky =
        window.pageYOffset + window.innerHeight >
        this.$el.getBoundingClientRect().top +
          window.pageYOffset +
          this.$refs.bar.offsetHeight;
      this.bottom =
        window.pageYOffset + window.innerHeight >
        document.querySelector("footer.footer").offsetTop;
    },
    addToCartAndFeedback(product) {
      const payload = this.size
        ? {
            productToAdd: {
              ...product,
              product_option: {
                extension_attributes: { custom_options: [this.size] },
              },
            },
          }
        : { productToAdd: product };
      this.addToCart(payload).then(() => {
        /* this.show({
          message: "Your product has been added to your shopping bag",
        }); */
      });
    },
    alertAvailability() {
      this.$emit("alertAvailability");
    },
    alertIcons() {
      this.$emit("alertIcons");
    },
    callGTM(event) {
      this.$gtm.trackEvent({
        event: event,
        products: [
          {
            name: this.item.product.name || "",
            id: this.item.product.sku || "",
            price: getProductPrice(this.item.product) || "",
            brand: "Zenith",
            category: "Watches",
            quantity: this.item.product.qty || "",
            productCase: this.item.product.option_value_material,
            productCaseSize: this.item.product.option_value_diameter,
            productColor: this.item.product.option_value_dial,
            productMasterId: this.item.product.collection,
            productSubCategory: "",
            productMidCategory: this.item.product.option_value_collection,
            productPowerReserve: this.item.product.option_value_power_reserve,
            productStock:
              this.item.product &&
              this.item.product.stock &&
              this.item.product.stock.is_in_stock
                ? "In stock"
                : "Out of stock",
            productStrap: this.item.product.option_value_bracelet,
            productWaterResistance:
              this.item.product.option_value_water_resistance,
          },
        ],
      });
    },
  },
  watch: {
    bottom() {
      if (this.bottom) {
        document.querySelector("main").classList.add("-relative");
      } else {
        document.querySelector("main").classList.remove("-relative");
      }
    },
  },
  computed: {
    accountActivated() {
      const { account } = currentStoreView();
      return account !== false;
    },
    localizedUrl() {
      return currentStoreView().url || "";
    },
  },
  destroyed: function () {
    document.querySelector("main").classList.remove("-product");
    window.removeEventListener("scroll", this.isSticky);
  },
};
</script>

<style lang="scss" scoped>
@import "~theme/css/core";

aside {
  .container {
    position: relative;
    z-index: 80;
    height: 12rem;
    display: flex;
    align-items: center;

    @include bp(max 1320px) {
      padding-right: 12rem;
    }

    @include bp(max 767px) {
      padding-right: 9rem;
    }

    @include bp(max md) {
      height: 9rem;
      justify-content: space-between;
    }

    &.-sticky {
      position: fixed;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }

    &.-bottom {
      position: absolute;
    }

    &:before {
      content: "";
      display: block;
      position: absolute;
      z-index: 5;
      top: 0;
      bottom: 0;
      left: 50%;
      width: 100vw;
      background: var(--zenith-sticky-product-bar-background);
      transform: translateX(-50%);
    }

    div.h5 {
      position: relative;
      z-index: 10;
      margin-right: auto;
      padding-right: 2rem;
      margin-bottom: 0;
      color: white;

      @include bp(max md) {
        display: none;
      }
    }

    .btn {
      z-index: 10;
      margin-left: 3rem;

      @include bp(max md) {
        margin-left: 0;
        height: 4rem;
        min-height: 4rem;
        font-size: em(10);
        padding-left: 1.5rem;
        padding-right: 1.5rem;

        &.-icon.-only {
          padding-left: 1.9rem;
          padding-right: 1.9rem;

          i {
            left: 0.8rem;
          }
        }

        &.-icon:not(.-only) {
          i {
            display: none;
          }
        }

        &.-ecom {
          display: none;
        }
      }

      &:not(.-stroke).-white {
        color: black;

        &:after {
          border-color: white;
          background-image: linear-gradient(
            -45deg,
            white,
            white,
            var(--zenith-theme-primary),
            var(--zenith-theme-primary)
          );
        }

        &:hover,
        &:active,
        &:focus {
          color: #f8f8f8;

          &:after {
            border-color: white;
            background-position: -0.2rem -0.2rem;
          }
        }
      }

      &:not(.-stroke)[disabled] {
        color: #999999;

        &:hover,
        &:active,
        &:focus {
          color: #999999;
        }
      }
    }
  }
}
</style>
